"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const getCampaignType_1 = require("../../views/utils/getCampaignType");
const isNotificationDeliveryModalOpen = (state = 'close', action) => {
    switch (action.type) {
        case 'OPEN_NOTIFICATION_DELIVERY_MODAL':
            return 'open';
        case 'CLOSE_NOTIFICATION_DELIVERY_MODAL':
            return 'close';
        case 'CLOSING_NOTIFICATION_DELIVERY_MODAL':
            return 'closing';
        default:
            return state;
    }
};
const lastViewPage = (state = '', action) => {
    switch (action.type) {
        case 'UPDATE_LAST_VIEW_PAGE':
            return action.lastViewPage;
        default:
            return state;
    }
};
const isTapBehaviorDeepLink = (state = false, action) => {
    switch (action.type) {
        case 'CREATE_EDITABLE_CAMPAIGN':
        case 'UPDATE_EDITABLE_CAMPAIGN':
            if (getCampaignType_1.isNotificationCampaignDeliverable(action.editableCampaign.deliverable)) {
                const { type, url } = action.editableCampaign.deliverable.tapBehavior;
                if (type !== 'OPEN_URL') {
                    return false;
                }
                if (!url) {
                    return true;
                }
                if (url.startsWith('http://') || url.startsWith('https://')) {
                    return false;
                }
                return true;
            }
            return state;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    isNotificationDeliveryModalOpen,
    isTapBehaviorDeepLink,
    lastViewPage,
});
exports.getIsNotificationDeliveryModalOpen = (state) => state.isNotificationDeliveryModalOpen;
exports.getLastViewPage = (state) => state.lastViewPage;
exports.getIsTapBehaviorDeepLink = (state) => state.isTapBehaviorDeepLink;
